import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Auth screens
    welcome: "Welcome to Freelanders",
    connectNomads: "Connect with nomads and freelancers worldwide",
    signIn: "Sign In",
    signUp: "Sign Up",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    fullName: "Full Name",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    sendResetLink: "Send Reset Link",
    backToSignIn: "Back to Sign In",
    signInWith: "Sign in with",
    signUpWith: "Sign up with",
    google: "Google",
    apple: "Apple",
    orContinueWith: "Or continue with",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    createAccount: "Create Account",
    enterEmail: "Enter your email",
    enterPassword: "Enter your password",
    enterFullName: "Enter your full name",
    confirmYourPassword: "Confirm your password",
    passwordResetSent: "Password reset link sent to your email",
    
    // Main app screens
    map: "Map",
    discover: "Discover",
    chat: "Chat",
    events: "Events",
    checkins: "Check-ins",
    profile: "Profile",
    
    // Map screen
    searchPlaceholder: "Search locations, events, people...",
    online: "Online",
    nearbyNomads: "nearby nomads",
    
    // Discovery screen
    findNomads: "Find nomads and freelancers nearby",
    all: "All",
    nearby: "Nearby",
    message: "Message",
    invite: "Invite",
    
    // Events screen
    connectMeetups: "Connect through local meetups",
    today: "Today",
    professional: "Professional",
    casual: "Casual",
    attending: "attending",
    joinEvent: "Join Event",
    
    // Chat screen
    messages: "Messages",
    stayConnected: "Stay connected with nomads",
    group: "Group",
    
    // Profile screen
    you: "You",
    editProfile: "Edit Profile",
    skillsExpertise: "Skills & Expertise",
    locationPrivacy: "Location & Privacy",
    notifications: "Notifications",
    account: "Account",
    locationSharing: "Location Sharing",
    visibleToNearby: "Visible to nearby nomads",
    discoveryRadius: "Discovery Radius",
    onlineStatus: "Show when active",
    newMessages: "New Messages",
    eventInvitations: "Event Invitations",
    nearbyPings: "Nearby Pings",
    enabled: "Enabled",
    subscription: "Subscription",
    freePlan: "Free Plan",
    dataExport: "Data Export",
    deleteAccount: "Delete Account",
    signOut: "Sign Out",
    language: "Language",
    
    // Check-ins screen
    shareJourney: "Share your nomad journey",
    shareLocation: "Share your location",
    letNomadsKnow: "Let nomads know where you're working from",
    checkInHere: "Check in here",
    recentActivity: "Recent Activity",
    likes: "likes",
    comments: "comments",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    loading: "Loading...",
    error: "Error",
    success: "Success"
  },
  tr: {
    // Auth screens
    welcome: "Freelanders'a Hoş Geldiniz",
    connectNomads: "Dünya çapında nomadlar ve freelancer'larla bağlantı kurun",
    signIn: "Giriş Yap",
    signUp: "Kayıt Ol",
    email: "E-posta",
    password: "Şifre",
    confirmPassword: "Şifreyi Onayla",
    fullName: "Ad Soyad",
    forgotPassword: "Şifrenizi mi unuttunuz?",
    resetPassword: "Şifreyi Sıfırla",
    sendResetLink: "Sıfırlama Bağlantısı Gönder",
    backToSignIn: "Girişe Dön",
    signInWith: "İle giriş yap",
    signUpWith: "İle kayıt ol",
    google: "Google",
    apple: "Apple",
    orContinueWith: "Veya devam et",
    alreadyHaveAccount: "Zaten hesabınız var mı?",
    dontHaveAccount: "Hesabınız yok mu?",
    createAccount: "Hesap Oluştur",
    enterEmail: "E-postanızı girin",
    enterPassword: "Şifrenizi girin",
    enterFullName: "Ad soyadınızı girin",
    confirmYourPassword: "Şifrenizi onaylayın",
    passwordResetSent: "Şifre sıfırlama bağlantısı e-postanıza gönderildi",
    
    // Main app screens
    map: "Harita",
    discover: "Keşfet",
    chat: "Sohbet",
    events: "Etkinlikler",
    checkins: "Check-in'ler",
    profile: "Profil",
    
    // Map screen
    searchPlaceholder: "Konum, etkinlik, kişi ara...",
    online: "Çevrimiçi",
    nearbyNomads: "yakındaki nomad",
    
    // Discovery screen
    findNomads: "Yakındaki nomad ve freelancer'ları bulun",
    all: "Tümü",
    nearby: "Yakında",
    message: "Mesaj",
    invite: "Davet Et",
    
    // Events screen
    connectMeetups: "Yerel buluşmalar aracılığıyla bağlantı kurun",
    today: "Bugün",
    professional: "Profesyonel",
    casual: "Günlük",
    attending: "katılıyor",
    joinEvent: "Etkinliğe Katıl",
    
    // Chat screen
    messages: "Mesajlar",
    stayConnected: "Nomadlarla bağlantıda kalın",
    group: "Grup",
    
    // Profile screen
    you: "Siz",
    editProfile: "Profili Düzenle",
    skillsExpertise: "Yetenekler ve Uzmanlık",
    locationPrivacy: "Konum ve Gizlilik",
    notifications: "Bildirimler",
    account: "Hesap",
    locationSharing: "Konum Paylaşımı",
    visibleToNearby: "Yakındaki nomadlara görünür",
    discoveryRadius: "Keşif Yarıçapı",
    onlineStatus: "Aktifken göster",
    newMessages: "Yeni Mesajlar",
    eventInvitations: "Etkinlik Davetleri",
    nearbyPings: "Yakındaki Ping'ler",
    enabled: "Etkin",
    subscription: "Abonelik",
    freePlan: "Ücretsiz Plan",
    dataExport: "Veri Dışa Aktarma",
    deleteAccount: "Hesabı Sil",
    signOut: "Çıkış Yap",
    language: "Dil",
    
    // Check-ins screen
    shareJourney: "Nomad yolculuğunuzu paylaşın",
    shareLocation: "Konumunuzu paylaşın",
    letNomadsKnow: "Nomadlara nerede çalıştığınızı bildirin",
    checkInHere: "Buraya check-in yap",
    recentActivity: "Son Aktiviteler",
    likes: "beğeni",
    comments: "yorum",
    
    // Common
    save: "Kaydet",
    cancel: "İptal",
    loading: "Yükleniyor...",
    error: "Hata",
    success: "Başarılı"
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Load saved language from localStorage
    const savedLanguage = localStorage.getItem('freelanders_language');
    if (savedLanguage && translations[savedLanguage]) {
      setLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (newLanguage) => {
    if (translations[newLanguage]) {
      setLanguage(newLanguage);
      localStorage.setItem('freelanders_language', newLanguage);
    }
  };

  const t = (key) => {
    return translations[language][key] || translations.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};